export const inServer = () => {
  return "object" === "undefined";
};
export const inClient = () => !inServer();
const BeanBucket = new Map();
export const ClientSingleton = function (Clazz) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  const id = Math.random().toFixed(10);
  return new Proxy({}, {
    get: (_target, _attr, _receiver) => {
      if (inClient()) {
        const instance = BeanBucket.get(id);
        if (instance) return instance[_attr];else {
          const newInstance = new Clazz(...args);
          BeanBucket.set(id, newInstance);
          return newInstance[_attr];
        }
      } else {
        console.log("被拒绝的访问", Clazz, _attr);
      }
    }
  });
};